export default "__VITE_ASSET__50bb4344__"